import { TextColors, TypographyStyles } from '@/styles'
import { Card, CardColors, Text } from '@/ui'

import { useBreakdownTransparency } from './useBreakdownTransparency'

/**
 * The plain-language answer to "how was this calculated", above the tables, for
 * customers who won't work through a column of subtractions. Renders nothing
 * when there are no sentences to show.
 */
export const PlainSummaryCard = ({ sentences }: { sentences: string[] }) => {
  const transparencyEnabled = useBreakdownTransparency()

  if (!transparencyEnabled || sentences.length === 0) {
    return null
  }

  return (
    <Card color={CardColors.LEVEL_1} className="mb-6">
      <div className="flex flex-col space-y-2 p-4">
        <Text variant={TypographyStyles.H3}>How we got to this number</Text>
        {sentences.map((sentence) => (
          <Text key={sentence} color={TextColors.MUTED}>
            {sentence}
          </Text>
        ))}
      </div>
    </Card>
  )
}
